import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type FormFieldGenerationParams } from '../../__base/generation';

export function generateVideoPlayerFormField(
  params: FormFieldGenerationParams<'videoPlayer'>,
): PartialPropsOf<'videoPlayer'> {
  const props: PartialPropsOf<'videoPlayer'> = applyPropsPatch(params.props, {
    content: {
      title: { enabled: true },
      videoSource: { enabled: false },
    },
    style: {
      video: { offset: { margin: '$t.spacingFormField' } },
    },
  });

  return props;
}
